<template>
  <modal :heightOverride="400" ref="modal" closeButton @closed="onClose">
    <div class="dropped_attributes_details">
      <template v-if="loading">
        <loader-dots class="dropped_attributes_details__loading" />
      </template>
      <template v-else >
        <div
          v-for="data in droppedAttributes" :key="data.quarter">
          <div class="dropped_attributes_details__quarter-panel">
            {{getQuarterString(data.quarter)}}
          </div>
          <div class="dropped_attributes_details__attribute-panel">
            <div
              v-for="(attribute, i) in data.attributes" :key="i">
              <oval-label class="dropped_attributes_details__attribute">
                {{attribute}}
              </oval-label>
            </div>
          </div>
        </div>
      </template>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/common/modal'
import {OvalLabel} from '@/components/common/ovalLabel'
import {getQuarterString} from '@/common/U_D'
import LoaderDots from '@/components/common/loaderDots'
import {sortStrings} from '@/common/U_SORT'
import {
  SET_TARGET_DROPPED_ATTRIBUTES,
  SHOW_DROPPED_ATTRIBUTES_MODEL
} from '@/appLogic/targets/currentTarget/store/actions'

export default {
  components: {
    Modal,
    OvalLabel,
    LoaderDots
  },
  data () {
    return {
      getQuarterString
    }
  },
  computed: {
    showModal () {
      return this.$store.state.currentTarget.showDroppedAttributesModal
    },
    currentTarget () {
      return this.$store.state.workbench.workbenchTarget
    },
    droppedAttributes () {
      const attributes = this.$store.state.currentTarget.droppedAttributes
      const dataAttributes = attributes.map(qa => {
        return {
          quarter: qa.quarter.start,
          attributes: qa.attributes.map(a => a.parent + ' - ' + a.name)
        }
      })
      for (const da of dataAttributes) {
        da.attributes = sortStrings(da.attributes)
      }
      return dataAttributes
    },
    loading () {
      return this.$store.state.currentTarget.isLoading
    }
  },
  methods: {
    open () {
      this.$refs.modal.open()
      this.$store.dispatch(SET_TARGET_DROPPED_ATTRIBUTES, this.currentTarget)
    },
    onClose () {
      this.$store.dispatch(SHOW_DROPPED_ATTRIBUTES_MODEL, false)
      this.close()
    },
    close () {
      this.$refs.modal.close()
    }
  },
  watch: {
    showModal () {
      if (this.showModal) {
        this.open()
      }
    }
  }
}
</script>

<style lang="scss">
.dropped_attributes_details {
  &__loading {
    margin: 100px auto;
  }

  &__quarter-panel {
    text-align: center;
    border-bottom: 1px solid red;
    margin: 0 auto;
    width: 600px;
    font-style: bold;
    font-size: 2em;
  }
  &__attribute-panel {
    margin: 0 auto;
    width: 600px;
    text-align: center;
  }

  &__attribute {
    background-color: red;
    color: white;
  }
}
</style>



// WEBPACK FOOTER //
// DroppedAttributesModal.vue?58698cac